
import GroupsQuery from "../../graphql/group/groups.graphql"
import * as cdn from "@coredination/components"
import Dialog from "../../base_classes/Dialog"
import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import modaldialog from "./modaldialog"

@Component({
    apollo: {
        groups: GroupsQuery,
        me: cdn.graphql.me
    }
})
export default class SelectGroupDialog extends Dialog {
    groups: any[] = []
    headers = [
        {
            text: "Name",
            value: "name",
            sortable: false
        }
    ]

    me: any = {}

    @Prop()
    readonly currentGroup?: string

    get fullscreen() {
        return this.$vuetify.breakpoint.xsOnly
    }

    select(item: any) {
        this.$emit("select", item)
        this.show = false
        if (item) this.storeSelection(item)
    }

    isCurrent(item: any) {
        var uuid: string = ""
        if (this.currentGroup) uuid = this.currentGroup
        else if (this.me && this.me.primaryGroupUuid) uuid = this.me.primaryGroupUuid
        return uuid ? uuid == item.uuid : false
    }
}
